import React, { createContext, useContext } from 'react';
import { BaseCreditCardFormState } from '@atlassian/commerce-credit-card-base';
import { CommerceIntlProvider } from '../../common/utils/locale';
import { CreateIntentSecretURLProvider, useHAMSServiceWithUrl } from '../../services/hams';
import { BrandValidationProvider } from '../../services/hams/brand-validation';
var hamsGatewayContext = /*#__PURE__*/createContext(undefined);
export var useHAMSGateway = function useHAMSGateway() {
  return useContext(hamsGatewayContext);
};
var CreditCardFormStateWithService = function CreditCardFormStateWithService(_ref) {
  var children = _ref.children,
    stripeKeyUrl = _ref.stripeKeyUrl,
    paymentMethodTokenUrl = _ref.paymentMethodTokenUrl,
    useStripeService = _ref.useStripeService;
  var hamsService = useHAMSServiceWithUrl(stripeKeyUrl);
  var token = hamsService.token;
  return /*#__PURE__*/React.createElement(CreateIntentSecretURLProvider, {
    value: paymentMethodTokenUrl
  }, /*#__PURE__*/React.createElement(hamsGatewayContext.Provider, {
    value: token.state === 'complete' ? token.payload.hams.gateway : undefined
  }, /*#__PURE__*/React.createElement(BaseCreditCardFormState, {
    commerceService: hamsService,
    useStripeService: useStripeService
  }, children)));
};
export var HAMSCreditCardFormState = function HAMSCreditCardFormState(_ref2) {
  var children = _ref2.children,
    stripeKeyUrl = _ref2.stripeKeyUrl,
    paymentMethodTokenUrl = _ref2.paymentMethodTokenUrl,
    useStripeService = _ref2.useStripeService;
  return /*#__PURE__*/React.createElement(CommerceIntlProvider, null, /*#__PURE__*/React.createElement(BrandValidationProvider, null, /*#__PURE__*/React.createElement(CreditCardFormStateWithService, {
    stripeKeyUrl: stripeKeyUrl,
    paymentMethodTokenUrl: paymentMethodTokenUrl,
    useStripeService: useStripeService
  }, children)));
};